import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllStoreCredits } from '../../store/actions/storeCreditAction'
import { CHANGE_STORE_CREDITS_PAGE } from '../../store/types'
import Layout from '../../components/Layout'
import { Container, Typography } from '@mui/material'
import SearchProduct from '../../components/product/SearchProduct'
import StoreCreditInfos from '../../components/storeCredit/StoreCreditInof'
import PagnationComponent from '../../components/PagnationComponent'

const StoreCredits = () => {
    const dispatch = useDispatch()

    const { storeCredits, pages, page, count, keyword } = useSelector(
        (state) => state.storeCredit
    )

    const pageNumber = page || 1
    useEffect(() => {
        dispatch(getAllStoreCredits(keyword, pageNumber))
    }, [dispatch, keyword, pageNumber])

    const changePage = useCallback(
        (page) => {
            dispatch({ type: CHANGE_STORE_CREDITS_PAGE, payload: page })
        },
        [dispatch]
    )

    return (
        <Layout>
            <Container>
                <SearchProduct displayKeyword={keyword} />
                <Typography
                    variant="body2"
                    gutterBottom
                    style={{ paddingBottom: '10px', paddingTop: '10px' }}
                >
                    Count: {count}
                </Typography>
                {storeCredits && (
                    <StoreCreditInfos storeCredits={storeCredits} />
                )}
                <PagnationComponent
                    page={pageNumber}
                    pages={pages}
                    func={changePage}
                />
            </Container>
        </Layout>
    )
}

export default StoreCredits
